/**
 * Rayon du secteur de génération d’interventions autour d’un bâtiment opérationnel (hors CTA).
 * Doit rester aligné avec `BUILDING_INTERVENTION_SPAWN_RADIUS_KM` côté serveur (`interventionSpawnZone.ts`).
 */
export const BUILDING_INTERVENTION_SPAWN_RADIUS_KM = 5;

/** Rayon Leaflet `L.circle` en mètres */
export const BUILDING_INTERVENTION_SPAWN_RADIUS_METERS = BUILDING_INTERVENTION_SPAWN_RADIUS_KM * 1000;
